import { createFileRoute, notFound } from "@tanstack/react-router";
import CatchAllPage from "#/features/slug-routes/CatchAllPage";
import { loadCatchAllPage } from "#/features/slug-routes/catch-all.functions";
import { metadataToHead, type PageMetadata } from "#/lib/seo";

const fallbackMetadata: PageMetadata = {
  description: "Roamdoc",
  metadataBase: "https://www.roamdoc.com",
  title: "Roamdoc",
};

export const Route = createFileRoute("/$")({
  loader: ({ params }) => {
    if (!params._splat) {
      throw notFound();
    }

    return loadCatchAllPage({
      data: {
        slug: params._splat,
      },
    });
  },
  head: ({ loaderData }) => metadataToHead(loaderData?.metadata ?? fallbackMetadata),
  component: RouteComponent,
});

function RouteComponent() {
  const data = Route.useLoaderData();

  return <CatchAllPage data={data} />;
}
